import {
  RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_SUCCESS,
  RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_ERROR,
  RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_START,
  SAVE_FOR_LATER,
  SAVE_FOR_LATER_SUCCESS,
  SAVE_FOR_LATER_ERROR,
  CLEAR_FIRST_TIME_PREVIOUS_REDUCER,
} from "Constant";
const initialState = {
  loading: false,
  data: [],
};

export default function FirstTimeApprovalDetailsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_START:
      return {
        ...state,
        loading: true,
        data: [],
      };
    case RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
        data: [],
      };
    case SAVE_FOR_LATER:
      return {
        ...state,
        loading: true,
        data: [],
      };
    case SAVE_FOR_LATER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case SAVE_FOR_LATER_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
        data: [],
      };
    case CLEAR_FIRST_TIME_PREVIOUS_REDUCER:
      return {
        data: [],
      };
    default:
      return state;
  }
}
